import mList from '_v/common/m-list'
import TenantAdvSearch from '_v/tenants/tenant-adv-search'
import SelectTags from '_vc/select-tags'

// 账单列表
export default {
    mixins: [mList],
    components: {
        TenantAdvSearch,
        SelectTags,
    },
    data() {
        return {
            enums: {
                IS_BIND: this.$enum.get('IS_BIND'),
            },
        }
    },
    computed: {
        orderBysList() {
            // prettier-ignore
            var list
            if (this.accessName === 'tenantsRent') {
                list = [
                    { id: 'planDate asc', text: '应付款日升序' },
                    { id: 'planDate desc', text: '应付款日降序' },
                    { id: 'houseName asc', text: '房源排序' },
                ]
            }
            if (this.accessName === 'tenantsHistory') {
                list = [{ id: 'houseName asc', text: '房源排序' }]
            }
            // prettier-ignore
            return list
        },
    },
    methods: {
        // 关闭搜索条件
        onAdvItemClose(item, index) {
            var key = item.key

            // daterange
            if (key.indexOf('-') >= 0) {
                var [k1, k2] = key.split('-')

                this.advFilter[k1] = ''
                this.advFilter[k2] = ''
            }
            // select
            else if (typeof this.advFilter[key] === 'object') {
                this.advFilter[key].splice(index, 1)
            }
            // others
            else {
                this.advFilter[key] = ''
            }

            this.$nextTick(() => this.search())
        },
        // 高级搜索
        onAdvConfirm(val, options) {
            this.advOptions = options
            this.$nextTick(() => this.search())
        },
        normalizeAdvFilter(advFilter) {
            var filter = Object.assign({}, advFilter)

            Object.keys(filter).forEach((k) => {
                switch (k) {
                    case 'billStatus':
                    case 'contractStatus':
                    case 'liveStatus':
                    case 'isWxBind':
                        if (filter[k].length) {
                            filter[k] = filter[k].join(',')
                        } else {
                            delete filter[k]
                        }

                        break
                }
            })

            return filter
        },
    },
}
